<template>
  <div style="margin: 0 -8px 0 2px" :style="{ width: 270 + 'px', minHeight: (minHeight ? minHeight : 200) + 'px' }"
    id="infoWindow" ref="infoWindow">
    <div class="baidu_h1">
      <b style="margin-right:4px;" @dblclick="utils.selectText('carNo')" id="carNo">{{
        locateData.name
      }}</b>

      <car-statue :realTimeStatus="locateData.realTimeStatus" :statusDuration="locateData.statusDuration"></car-statue>

    </div>
    <Tag v-for="(t, indexx) in locateData.carLabelList" color="red" :key="indexx">{{ t }}</Tag>
    <p>{{ address }}</p>
    <ul class="msg clearfloat" v-if="locateData.deviceUseType == 1">
      <Row>
        <Col span="24">
        <Row>
          <Col span="12">
          <ly-form-item label="当前速度">{{ locateData.speed }}km/h</ly-form-item>
          </Col>
          <Col span="12">
          <ly-form-item lw="3.5" label="里程数">{{ locateData.mileage }}km</ly-form-item> </Col>
          <Col span="12">
          <ly-form-item label="当前油量">{{ locateData.oilLiters }}L</ly-form-item>
          </Col>
          <Col span="12" v-show="locateData.deviceUseType == 1">
          <ly-form-item lw="3.5" label="发动机">{{
            locateData.accStatus
          }}</ly-form-item>
          </Col>

          <Col span="24">
          <ly-form-item label="北斗时间">{{
            locateData.gpsTime
          }}</ly-form-item>
          </Col>
          <Col span="24">
          <ly-form-item label="信号时间">{{
            utils.time(locateData.heartbeatTime)
          }}</ly-form-item>
          </Col>
          <Col span="24">
          <ly-form-item label="设备电量">
            <elect :num="locateData.electricity"></elect>
          </ly-form-item>
          </Col>
          <Col span="24" v-show="locateData.deviceUseType == 1">
          <ly-form-item label="更多信息"><a @click="openMore = true">点击这里查看</a></ly-form-item>
          </Col>
        </Row>
        </Col>
      </Row>
    </ul>
    <ul class="msg clearfloat" v-if="locateData.deviceUseType == 2">
      <Row v-if="locateData.deviceUseType == 2">
        <Col span="24">
        <Row>
          <Col span="24">
          <ly-form-item label="设备电量">
            <elect :num="locateData.electricity"></elect>
          </ly-form-item>
          </Col>
          <Col span="24">
          <ly-form-item label="北斗时间">{{
            locateData.gpsTime
          }}</ly-form-item>
          </Col>

        </Row>
        </Col>
      </Row>
    </ul>
    <ul class="caozuo" v-if="locateData.deviceUseType == 1">
      <Button size="small" @click="guiji()">轨迹</Button>
      <Button size="small" @click="lookStree">街景</Button>
      <Button size="small" @click="adddd(locateData)">视频</Button>
      <Button size="small" @click="share(locateData)">分享</Button>
      <Button size="small" @click="zhiling(locateData)">指令</Button>
    </ul>
    <ul class="caozuo" v-if="locateData.deviceUseType == 2">
      <Button size="small" @click="locusPeson()">历史轨迹</Button>
      <Button size="small" @click="openMore = true">更多信息</Button>
    </ul>
    <Drawer title="更多信息" placement="right" :closable="true" :mask="true" :draggable="false" width="240"
      v-model="openMore">
      <Row>
        <Col span="24" v-show="!x.showIn" v-for="(x, index) in forms" :key="index">
        <ly-form-item :label="x.title">{{ locateData[x.key] }}</ly-form-item>
        </Col>
      </Row>
    </Drawer>
    <stree ref="bmapStree"></stree>
    <zhiling ref="zhiling"></zhiling>
    <share ref="share"></share>
  </div>
</template>
<script>
import carStatue from "../common/carStatue.vue";
import stree from "./com/stree.vue";
import zhiling from "./com/zhiling.vue";
import share from "./share/index.vue";
import elect from "./com/elect.vue";
export default {
  props: ["windowData", "minHeight"],
  components: { carStatue, stree, zhiling, share, elect },
  data() {
    return {
      openMore: false,
      isTrack: false,
      address: "",
      personForms: [
        {
          title: "工牌号",
          key: "personJobNo",
          showType: "text",
          sort: 1,
        },
        {
          title: "联系电话",
          key: "personTel",
          sort: 1,
        },
        {
          title: "速度",
          key: "speed",
          sort: 1,
        },
        {
          title: "里程/km",
          key: "mileage",
          sort: 1,
        },
      ],
      commonforms: [
        {
          title: "设备类型",
          key: "deviceModel",
        },
        {
          title: "设备号",
          key: "deviceNo",
        },
        {
          title: "sim卡号",
          key: "simNo",
        },
        {
          title: "原始经度",
          key: "orgX",
        },
        {
          title: "原始纬度",
          key: "orgY",
        },
        {
          title: "高德经度",
          key: "locateLng",
        },
        {
          title: "高德纬度",
          key: "locateLat",
        },
        {
          title: "事件说明",
          key: "eventDesc",
        },
        {
          title: "报警类型",
          key: "alarmList",
        },
      ],
      carForms: [
        {
          title: "车辆类型",
          key: "carTypeName",
        },
        {
          title: "称重",
          key: "weight",
          sort: 1,
        },
        {
          title: "驾驶员",
          key: "driverName",
        },
        {
          title: "司机电话",
          key: "driverTel",
        },
      ],
      forms: [],
      width: 100,
      locateData: {

      }
    };
  },
  methods: {
    cols(deviceUseType) {
      var b = this.commonforms;
      //b.splice(2, 4);
      for (let i = 0; i < b.length; i++) {
        b[i].sort = i + 1;

        if (b[i].key1) {
          b[i].key = b[i].key1;
        }
        if (b[i].key2) {
          b[i].key = b[i].key2;
        }
      }

      //this.columns.splice(3, 0, ...b);

      if (deviceUseType == 1) {
        this.forms = this.carForms.concat(b).sort(function up(x, y) {
          return x.sort - y.sort;
        });
      } else {
        this.forms = this.personForms.concat(b).sort(function up(x, y) {
          return x.sort - y.sort;
        });
      }
      //a.splice.apply(a,[i,0].concat(b));//es5写法
    },
    //点击轨迹按钮
    guiji(s) {
      this.$store.state.carMsg.carNo = this.locateData.name; //车牌号给客户
      this.$store.state.carMsg.deviceNo = this.locateData.deviceNo; //车牌号给客户
      this.utils.changeTopMenu(this, { name: "行车轨迹", link: "/locus" });
      this.$router.push({ path: "/locus" });
    },
    locusPeson(s) {
      this.$store.state.personMsg.name = this.locateData.name; //车牌号给客户
      this.$store.state.personMsg.deviceNo = this.locateData.deviceNo; //车牌号给客户
      this.utils.changeTopMenu(this, { name: "轨迹回放", link: "/locusPeson" });
      this.$router.push({ path: "/locusPeson" });
      //http://localhost:2201/#/locusPeson?now=1
    },
    //点击轨迹按钮
    lookOil(s) {
      if (this.locateData.oilVolume == null) {
        this.$Message.error("未安装油针");
        return;
      }
      this.$store.state.carMsg.carNum = this.locateData.num; //车牌号给客户看的
      this.$store.state.carMsg.deviceId = this.locateData.deviceId; //上传后台的参数
      this.$store.state.carMsg.select = s; //是否立即看轨迹
      this.$store.state.carMsg.lookOilNow = true; //是否立即看轨迹
      this.$router.push({ path: "/oil/?now=1" });
    },
    //百度街景
    lookStree() {
      this.$refs.bmapStree.open(this.locateData);
    },
    //实时视频
    adddd(t) {
      if (this.locateData.carLabelList.includes("视频")) {
        this.$emit("video", t);
      } else {
        this.$Message.warning({
          content: "车辆未贴‘视频’标签",
          duration: 2,
        });
      }
    },
    zhiling() {
      this.$refs.zhiling.open(this.locateData);
    },
    share() {
      this.$refs.share.open(this.locateData);
    },
  },
  watch: {
    windowData(m) {
      console.log(m);
      this.locateData = m;

      m.weight = "";
      if (m.extend != null) {
        m.extend1 = JSON.parse(m.extend);
        m.weight = m.extend.weight;
      }

      if (this.locateData.serviceSchedule != undefined) {
        this.locateData.serviceSchedule =
          this.locateData.serviceSchedule.replace(/\|/g, " ");
        this.locateData.serviceSchedule =
          this.locateData.serviceSchedule.replace(/#/g, "<br/>");
        this.locateData.serviceSchedule =
          this.locateData.serviceSchedule.replace(/,/g, "<br/>");
      }

      this.cols(m.deviceUseType);
      if (m.deviceUseType == 2) {
        this.width = 280;
      } else {
        this.width = 340;
      }
      //this.isTrack=false;
      var pointList = [
        {
          x: m.orgX,
          y: m.orgY,
        },
      ];
      this.utils.jiexi(pointList).then((data) => {
        this.address = data[0].address;
      });
    },
  },
  mounted() {
    //console.log(this.windowData);
  },
};
</script>
<style lang="">
.baidu_h1 {
  font-size: 1.3em;
  color: #333;
  margin-top: 0;
  font-weight: 500;
  margin-bottom: 6px;
  margin-left: 0px;
  font-weight: lighter;
  display:flex;
  
}
.baidu_h1 .carLabel {
  color: #fff;
  font-size: 10px;
  padding: 1px 4px;
  border-radius: 10px;
  position: relative;
  top: -2px;
}
.baidu_h1 span {
  font-size: 12px;
}
.red {
  color: #fc3737;
}
#address {
  /* overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis; */
  font-size: 12px;
  margin-left: 0px;
}
.msg {
  margin-top: 10px;
  line-height: 1;
  width: 100%;
  padding: 0px 0px 4px 0px;
}
.msg label {
  color: #999;
  margin-right: 6px;
  font-size: 12px;
}
.msg span {
  color: #333;
  margin-right: 6px;
  font-size: 12px;
}
.caozuo {
  display: flex;
  margin-top: 8px;
  padding-left: 0px;
}
.caozuo button {
  margin-right: 4px;
}
.serviceScheduleserviceSchedule {
  background: #989898;
  height: 80px;
  width: 80px;
  text-align: center;
}
#windownDataimg {
  height: 74px;
  background: #ccc;
  border: solid 1px #aaa;
  cursor: pointer;
}
.viewer-canvas img {
  background: #fff;
}
</style>


// WEBPACK FOOTER //
// src/components/locate/iconWindow.vue